// extracted by mini-css-extract-plugin
export default {"container":"startPage_container__J0cQa"};